import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import { SxProps } from '@mui/joy/styles/types';

import { ReactNode, RefObject } from 'react';

import { CopyButton } from './CopyButton/CopyButton';

interface HeaderProps {
  bodyRef?: RefObject<HTMLDivElement>;
  withJumpButton?: boolean;
  text: ReactNode;
  textSx?: SxProps;
  copy?: string;
  useIconCopyButton?: boolean;
  sx?: SxProps;
  right?: ReactNode;
  rightSx?: SxProps;
  className?: string;
}

const Header = ({
  text,
  textSx,
  copy,
  useIconCopyButton,
  bodyRef,
  sx,
  right,
  rightSx,
  withJumpButton,
  className,
}: HeaderProps) => {
  return (
    <Box
      sx={sx}
      height={32}
      marginBottom={1}
      display="flex"
      justifyContent={'space-between'}
      alignItems={'center'}
      className={className}
    >
      <Typography level="h6" sx={textSx}>
        {text}
      </Typography>
      <Box display="flex" alignItems={'center'} gap={1} sx={rightSx}>
        {right}
        {withJumpButton ? (
          <Button
            size={'sm'}
            color="neutral"
            variant="outlined"
            sx={{ userSelect: 'none' }}
            onClick={() =>
              bodyRef?.current
                ? window.scrollTo({
                    behavior: 'smooth',
                    top:
                      bodyRef.current.offsetTop +
                      bodyRef.current.offsetHeight -
                      50,
                  })
                : null
            }
          >
            Jump to bottom
          </Button>
        ) : null}
        {copy != null && (
          <Box>
            <CopyButton
              copy={copy}
              className="user-select-none opacity-70"
              variant={useIconCopyButton ? 'icon' : 'full'}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Header;
